export default __webpack_public_path__ + "static/media/RecycleBinEmpty.52619ca5.svg";